import React from 'react';

/**
 * HeroImageOnly - Clean hero section with image only, no text overlay
 * @param {string} imageSrc - URL of the hero background image
 * @param {string} imageAlt - Alt text for the image
 * @param {string} height - Tailwind height classes (default: "h-[400px] md:h-[480px] lg:h-[520px]")
 */
const HeroImageOnly = ({ 
  imageSrc, 
  imageAlt = "Hero image",
  height = "h-[400px] md:h-[480px] lg:h-[520px]"
}) => {
  return (
    <section className={`hero-main relative ${height} overflow-hidden`}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover object-center"
        />
        {/* Subtle cinematic vignette for navbar contrast only */}
        <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-[#050816]/50 to-transparent"></div>
      </div>
    </section>
  );
};

export default HeroImageOnly;
